import VideoContainer from "./VideoContainer"

const Main=()=>{
    return (
        <div className="col-span-11 pt-36  ">
            <VideoContainer/>
        </div>
    )
}
export default Main